'use client'

import { useTranslations } from 'next-intl'
import { SkeletonItem } from '@repo/design-system-cf/components/skeleton-item/index'

export function LoggedInSkeleton() {
  const t = useTranslations('pages.coins')

  return (
    <section
      role="status"
      aria-label={t('loading')}
      aria-busy="true"
      className="bg-cf-grey-50 mx-auto flex w-full flex-col items-center px-5 py-16 lg:py-20"
    >
      <div aria-hidden="true" className="grid w-full max-w-6xl gap-10 lg:grid-cols-3 lg:gap-20">
        <div className="bg-cf-grey-0 flex flex-col gap-6 rounded-lg p-5 lg:col-span-2 lg:p-10">
          <SkeletonItem className="h-6 w-32" />
          <SkeletonItem className="h-12 w-48" />
          <SkeletonItem className="mt-8 h-4" />
          <SkeletonItem className="h-5 w-40" />
        </div>
        <div className="flex flex-col gap-6 rounded-lg p-5 lg:p-10">
          <SkeletonItem className="h-8 w-40" />
          <SkeletonItem className="h-24" />
          <SkeletonItem className="h-12" />
        </div>

        <div className="flex flex-col gap-6 lg:col-span-3">
          <SkeletonItem className="h-8 w-40" />
          <SkeletonItem className="h-12" />
          <SkeletonItem className="h-12" />
          <SkeletonItem className="h-12" />
        </div>
      </div>
    </section>
  )
}
